module.exports = __webpack_public_path__ + "img/perforaciones_4-3_3072.5d615979.webp";